import React from 'react';
import { HandleExceptionErrorPage } from 'views/pages/errors/HandleExceptionErrorPage';

// eslint-disable-next-line @typescript-eslint/ban-types
type ErrorBoundaryProps = {};
type ErrorBoundaryState = {
  error?: Error;
};

export class ErrorBoundary extends React.Component<
  ErrorBoundaryProps,
  ErrorBoundaryState
> {
  constructor(props: ErrorBoundaryProps) {
    super(props);
    this.state = { error: undefined };
  }

  componentDidCatch(e: Error): void {
    this.setState({
      error: e,
    });
  }

  render(): React.ReactNode {
    const { error } = this.state;

    if (error) {
      return <HandleExceptionErrorPage error={error} />;
    }

    return this.props.children;
  }
}
